import {
  CheckCircleIcon,
  CurrencyDollarIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';
import type { ComponentType, SVGProps } from 'react';
import type { tCloseType } from './LeadClose.types';

/** The icon of each result, as the prototype draws them (Heroicons 24 outline). */
export const RESULT_ICON: Record<
  tCloseType,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  sold: CurrencyDollarIcon,
  lost: XCircleIcon,
  resolved: CheckCircleIcon,
};

// The prototype's tray glyphs, drawn on the Heroicons 24 outline grid.
const BILL =
  'M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.375 4.5h17.25c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125H3.375a1.125 1.125 0 0 1-1.125-1.125v-9.75c0-.621.504-1.125 1.125-1.125Z';
const TRAY_PATH: Record<tCloseType, string> = {
  sold: BILL + 'M12 7.75v5.5M9.25 10.5h5.5',
  lost:
    BILL +
    'M9.5 9h.008v.008H9.5V9Zm5 0h.008v.008H14.5V9ZM9.6 13.1c.55-.8 1.4-1.25 2.4-1.25s1.85.45 2.4 1.25',
  resolved:
    'M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632ZM10.6 5.2h.008v.008H10.6V5.2Zm2.8 0h.008v.008H13.4V5.2ZM10.5 6.9c.4.45.9.7 1.5.7s1.1-.25 1.5-.7',
};

/** billPlus / billSad / userHappy of the drop tray. */
export function TrayIcon({
  type,
  ...props
}: { type: tCloseType } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d={TRAY_PATH[type]} />
    </svg>
  );
}
